import {Box, Flex, Image, Text} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/revise/volume_2.svg'
import RepeatIcon from '@assets/svgs/revise/repeat.svg'
import TagUserIcon from '@assets/svgs/revise/tag_user.svg'
import FemaleImage from '@assets/images/revise/female-loading.png'
import {Progress} from 'antd'
import {useEffect, useState} from 'react'

const LoadingScreen = ({
  setIsLoadingProgress,
  dataQuestions,
}: {
  setIsLoadingProgress: any
  dataQuestions: any
}) => {
  const [percent, setPercent] = useState<any>(0)

  useEffect(() => {
    const intervalPercent = setInterval(() => {
      if (percent > 75 && !dataQuestions) {
        clearInterval(intervalPercent)
        return
      }
      if (percent < 100) {
        setPercent((pre: any) => pre + 2)
      } else {
        clearInterval(intervalPercent)
        setTimeout(() => {
          setIsLoadingProgress(false)
        }, 1000)
      }
    }, 100)
    return () => {
      clearInterval(intervalPercent)
    }
  }, [percent, dataQuestions])

  return (
    <Flex h={'100vh'} alignItems={'center'}>
      <Flex
        w={'100%'}
        h={'550px'}
        bg={'white'}
        flexDirection={'column'}
        justifyContent={'center'}>
        <Flex
          gap={{base: '12px', md: '32px'}}
          mx={'auto'}
          justifyContent={'center'}
          alignItems={'center'}>
          <Flex flexDirection={'column'} gap={{base: '20px', md: '32px'}}>
            <Text
              fontSize={'13px'}
              color={'#8C8C8C'}
              ml={'30px'}
              mr={'50px'}
              opacity={percent > 0 ? 1 : 0}
              transition={'2s'}>
              IELTS Coach tạo bài tập dựa trên phương pháp
            </Text>
            <Flex
              ml={'auto'}
              w={'fit-content'}
              p={'8px 16px'}
              bg={'#E6F7FF'}
              borderRadius={'16px'}
              gap={'8px'}
              alignItems={'center'}
              opacity={percent > 25 ? 1 : 0}
              transition={'2s'}>
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={'#096DD9'}
                fontWeight={600}>
                Nghe hiểu chủ động
              </Text>
              <Image src={VolumeIcon} />
            </Flex>
            <Flex
              w={'fit-content'}
              p={'8px 16px'}
              bg={'#E6F7FF'}
              borderRadius={'16px'}
              gap={'8px'}
              alignItems={'center'}
              opacity={percent > 50 ? 1 : 0}
              transition={'2s'}>
              <Image src={RepeatIcon} />
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={'#096DD9'}
                fontWeight={600}>
                Lặp lại ngắt quãng
              </Text>
            </Flex>
            <Flex
              ml={'auto'}
              w={'fit-content'}
              p={'8px 16px'}
              bg={'#E6F7FF'}
              borderRadius={'16px'}
              gap={'8px'}
              alignItems={'center'}
              opacity={percent > 75 ? 1 : 0}
              transition={'2s'}>
              <Text fontSize={'13px'} color={'#096DD9'}>
                và
              </Text>
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={'#096DD9'}
                fontWeight={600}>
                Nội dung cá nhân hoá
              </Text>
              <Image src={TagUserIcon} />
            </Flex>
          </Flex>
          <Image src={FemaleImage} w={{base: '100px', md: 'unset'}} />
        </Flex>
        <Flex
          w={'100%'}
          maxW={'400px'}
          mt={{base: '30px', md: 'unset'}}
          mx={'auto'}
          gap={'4px'}
          flexDirection={'column'}>
          <Progress
            percent={percent}
            showInfo={false}
            strokeColor={'#1890FF'}
          />
          <Text align={'center'} color={'#40A9FF'} fontSize={'13px'}>
            Chờ xíu, đang chuẩn bị bài cho bạn nè ...
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default LoadingScreen
